import CustomerTableForConsolidationRevenue from './CustomerTableForConsolidateRevenue';
import { useGetConsolidateSourceRevenue } from 'hooks/uesGetConsolidateRevenue';
import { transformDataToTable } from './utils';
import { useMemo } from 'react';
import { GetConsolidateRevenueData, TransformedRevenueData } from 'services/api/type/report.type';
import { useTranslation } from 'react-i18next';

interface UsedRoomsFiltersProps {
  filterOptions: any;
  isEnable: boolean;
  setDataSource: (data: any[]) => void;
  branch_ids: string | undefined;
}

export default function SourceTab({
  filterOptions,
  isEnable,
  setDataSource,
  branch_ids
}: UsedRoomsFiltersProps) {
  const { t } = useTranslation();
  const { data: consolidateRevenue, isLoading } = useGetConsolidateSourceRevenue(
    filterOptions,
    isEnable,
    branch_ids
  );

  const dataSource = useMemo(() => {
    if (consolidateRevenue) {
      return transformDataToTable(
        consolidateRevenue as unknown as GetConsolidateRevenueData,
        t
      ) as unknown as TransformedRevenueData[];
    }
    return [];
  }, [consolidateRevenue, t]);

  return (
    <CustomerTableForConsolidationRevenue
      loading={isLoading}
      dataSource={dataSource}
      title={t('bookingPage.bookingList.source')}
      filterOptions={filterOptions}
      branch_ids={branch_ids}
      setDataSource={setDataSource}
    />
  );
}
